// Eskom PARCC — card primitive.
//
// Thin wrapper over the monolith's `.card` panel. When `title` or `actions` are
// supplied it renders a `.section-head` header row (title on the left, actions
// on the right) matching the monolith's section layout; otherwise it is just a
// padded panel around its children.
import type { ReactNode } from 'react';

export function Card({
  title,
  subtitle,
  actions,
  className,
  children,
}: {
  /** Optional heading text rendered in a `.section-head` row. */
  title?: ReactNode;
  /** Optional secondary line under the title (uses `.small`). */
  subtitle?: ReactNode;
  /** Optional right-aligned controls (buttons, filters) in the header row. */
  actions?: ReactNode;
  /** Extra class(es) composed onto `.card` (e.g. a dashboard span class). */
  className?: string;
  children?: ReactNode;
}): React.JSX.Element {
  const hasHeader = title !== undefined || subtitle !== undefined || actions !== undefined;
  return (
    <div className={className ? `card ${className}` : 'card'}>
      {hasHeader && (
        <div className="section-head">
          <div>
            {title !== undefined && <h3>{title}</h3>}
            {subtitle !== undefined && <div className="small">{subtitle}</div>}
          </div>
          {actions !== undefined && <div className="actions">{actions}</div>}
        </div>
      )}
      {children}
    </div>
  );
}
